import { Fragment, type ReactNode } from 'react';

import Loading from '@cartwhl/ui/atoms/Loading';

export interface ProfileTabLoadingStateProps {
  className?: string;
  maxWidthClassName?: string;
}

export default function ProfileTabLoadingState({
  className,
  maxWidthClassName = 'max-w-(--breakpoint-md)',
}: ProfileTabLoadingStateProps) {
  return (
    <div className={`mx-auto ${maxWidthClassName} ${className ?? ''}`}>
      <div className="mt-8 flex flex-col gap-4">
        <div className="bg-gray-30 dark:bg-gray-60 h-5 w-24 animate-pulse rounded" />
        <div className="border-primary flex h-[210px] items-center justify-center rounded-lg border p-6">
          <Loading className="text-gray-30" />
        </div>
      </div>
    </div>
  );
}
